import { useTranslation } from 'next-i18next'

import ShowLoginForm from '~/auth/components/ShowLoginForm'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function AppLoginPage(): React.ReactElement {
  const { t } = useTranslation('start')

  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isTablet = useCheckBreakpoint({ lt: Breakpoint.LG })
  const imageHeight = isMobile ? 31 : isTablet ? 45 : 68
  const imageWidth = isMobile ? 160 : isTablet ? 232 : 355

  return (
    <div className="relative flex justify-center bg-gradient-purple-dark-violet ">
      <div className="flex flex-col items-center pt-8 w-full max-w-132 min-h-screen overflow-x-hidden justify-end lg:justify-center z-100">
        <ResponsiveImage
          className="mb-8"
          height={imageHeight}
          loading="eager"
          srcKey="logos/house-of-math-logo-white.png"
          width={imageWidth}
        />

        <div className="flex flex-col items-center w-full">
          <ResponsiveImage
            alt={t('intro.heading')}
            fetchPriority="high"
            height={1200}
            imageClassName="object-contain w-96 -mb-24 -ml-8"
            loading="eager"
            srcKey="misc/eivind-avatar.png"
          />
          <div className="bg-purple-void rounded-t-4xl md:rounded-4xl text-white px-4 py-6 md:px-15 md:py-10 min-w-full">
            <ShowLoginForm isMobileApp />
          </div>
        </div>
      </div>
    </div>
  )
}
